/**
 * Engine API
 * Civilization Engine API
 *
 * OpenAPI spec version: 1.0
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 *//* tslint:disable:no-unused-variable member-ordering */

import { Inject, Injectable, Optional }                      from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams,
         HttpResponse, HttpEvent }                           from '@angular/common/http';
import { CustomHttpUrlEncodingCodec }                        from '../encoder';

import { Observable }                                        from 'rxjs';

import { BattleExistedFrontAction } from '../model/battleExistedFrontAction';
import { BattleFrontAction } from '../model/battleFrontAction';
import { BattleNewFrontAction } from '../model/battleNewFrontAction';
import { BattleStartAction } from '../model/battleStartAction';
import { BattleWoundsAction } from '../model/battleWoundsAction';
import { CivAction } from '../model/civAction';
import { CivUuidAction } from '../model/civUuidAction';
import { GameEngineDto } from '../model/gameEngineDto';

import { BASE_PATH, COLLECTION_FORMATS }                     from '../variables';
import { Configuration }                                     from '../configuration';


@Injectable()
export class EngineBattleService {

    protected basePath = 'http://localhost:8080/engine';
    public defaultHeaders = new HttpHeaders();
    public configuration = new Configuration();

    constructor(protected httpClient: HttpClient, @Optional()@Inject(BASE_PATH) basePath: string, @Optional() configuration: Configuration) {
        if (basePath) {
            this.basePath = basePath;
        }
        if (configuration) {
            this.configuration = configuration;
            this.basePath = basePath || configuration.basePath || this.basePath;
        }
    }

    /**
     * @param consumes string[] mime-types
     * @return true: consumes contains 'multipart/form-data', false: otherwise
     */
    private canConsumeForm(consumes: string[]): boolean {
        const form = 'multipart/form-data';
        for (const consume of consumes) {
            if (form === consume) {
                return true;
            }
        }
        return false;
    }


    /**
     * Add wounds
     * Add wounds to unit in front
     * @param body 
     * @param gameId Game ID
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public addWounds(body: BattleWoundsAction, gameId: number, observe?: 'body', reportProgress?: boolean): Observable<GameEngineDto>;
    public addWounds(body: BattleWoundsAction, gameId: number, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<GameEngineDto>>;
    public addWounds(body: BattleWoundsAction, gameId: number, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<GameEngineDto>>;
    public addWounds(body: BattleWoundsAction, gameId: number, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (body === null || body === undefined) {
            throw new Error('Required parameter body was null or undefined when calling addWounds.');
        }

        if (gameId === null || gameId === undefined) {
            throw new Error('Required parameter gameId was null or undefined when calling addWounds.');
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json;charset=UTF-8'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.request<GameEngineDto>('post',`${this.basePath}/api/engine/${encodeURIComponent(String(gameId))}/actions/battle/add-wounds`,
            {
                body: body,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Attack front
     * Attack existed battle front and calculate unit damages
     * @param body 
     * @param gameId Game ID
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public attackFront(body: BattleExistedFrontAction, gameId: number, observe?: 'body', reportProgress?: boolean): Observable<GameEngineDto>;
    public attackFront(body: BattleExistedFrontAction, gameId: number, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<GameEngineDto>>;
    public attackFront(body: BattleExistedFrontAction, gameId: number, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<GameEngineDto>>;
    public attackFront(body: BattleExistedFrontAction, gameId: number, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (body === null || body === undefined) {
            throw new Error('Required parameter body was null or undefined when calling attackFront.');
        }

        if (gameId === null || gameId === undefined) {
            throw new Error('Required parameter gameId was null or undefined when calling attackFront.');
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json;charset=UTF-8'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.request<GameEngineDto>('post',`${this.basePath}/api/engine/${encodeURIComponent(String(gameId))}/actions/battle/attack-front`,
            {
                body: body,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Finish battle
     * Finish battle
     * @param body 
     * @param gameId Game ID
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public finishBattle(body: CivAction, gameId: number, observe?: 'body', reportProgress?: boolean): Observable<GameEngineDto>;
    public finishBattle(body: CivAction, gameId: number, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<GameEngineDto>>;
    public finishBattle(body: CivAction, gameId: number, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<GameEngineDto>>;
    public finishBattle(body: CivAction, gameId: number, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (body === null || body === undefined) {
            throw new Error('Required parameter body was null or undefined when calling finishBattle.');
        }

        if (gameId === null || gameId === undefined) {
            throw new Error('Required parameter gameId was null or undefined when calling finishBattle.');
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json;charset=UTF-8'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.request<GameEngineDto>('post',`${this.basePath}/api/engine/${encodeURIComponent(String(gameId))}/actions/battle/finish`,
            {
                body: body,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Form front
     * Form existed battle front without calculating unit damages
     * @param body 
     * @param gameId Game ID
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public formFront(body: BattleExistedFrontAction, gameId: number, observe?: 'body', reportProgress?: boolean): Observable<GameEngineDto>;
    public formFront(body: BattleExistedFrontAction, gameId: number, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<GameEngineDto>>;
    public formFront(body: BattleExistedFrontAction, gameId: number, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<GameEngineDto>>;
    public formFront(body: BattleExistedFrontAction, gameId: number, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (body === null || body === undefined) {
            throw new Error('Required parameter body was null or undefined when calling formFront.');
        }

        if (gameId === null || gameId === undefined) {
            throw new Error('Required parameter gameId was null or undefined when calling formFront.');
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json;charset=UTF-8'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.request<GameEngineDto>('post',`${this.basePath}/api/engine/${encodeURIComponent(String(gameId))}/actions/battle/form-front`,
            {
                body: body,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Kill random unit
     * Kill random civilization unit
     * @param body 
     * @param gameId Game ID
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public killRandomUnit(body: CivAction, gameId: number, observe?: 'body', reportProgress?: boolean): Observable<GameEngineDto>;
    public killRandomUnit(body: CivAction, gameId: number, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<GameEngineDto>>;
    public killRandomUnit(body: CivAction, gameId: number, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<GameEngineDto>>;
    public killRandomUnit(body: CivAction, gameId: number, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (body === null || body === undefined) {
            throw new Error('Required parameter body was null or undefined when calling killRandomUnit.');
        }

        if (gameId === null || gameId === undefined) {
            throw new Error('Required parameter gameId was null or undefined when calling killRandomUnit.');
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json;charset=UTF-8'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.request<GameEngineDto>('post',`${this.basePath}/api/engine/${encodeURIComponent(String(gameId))}/actions/battle/kill-random-unit`,
            {
                body: body,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Kill unit
     * Kill unit in one of fronts
     * @param body 
     * @param gameId Game ID
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public killUnit(body: BattleFrontAction, gameId: number, observe?: 'body', reportProgress?: boolean): Observable<GameEngineDto>;
    public killUnit(body: BattleFrontAction, gameId: number, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<GameEngineDto>>;
    public killUnit(body: BattleFrontAction, gameId: number, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<GameEngineDto>>;
    public killUnit(body: BattleFrontAction, gameId: number, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (body === null || body === undefined) {
            throw new Error('Required parameter body was null or undefined when calling killUnit.');
        }

        if (gameId === null || gameId === undefined) {
            throw new Error('Required parameter gameId was null or undefined when calling killUnit.');
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json;charset=UTF-8'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.request<GameEngineDto>('post',`${this.basePath}/api/engine/${encodeURIComponent(String(gameId))}/actions/battle/kill-unit`,
            {
                body: body,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * New front
     * Create new battle front
     * @param body 
     * @param gameId Game ID
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public newFront(body: BattleNewFrontAction, gameId: number, observe?: 'body', reportProgress?: boolean): Observable<GameEngineDto>;
    public newFront(body: BattleNewFrontAction, gameId: number, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<GameEngineDto>>;
    public newFront(body: BattleNewFrontAction, gameId: number, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<GameEngineDto>>;
    public newFront(body: BattleNewFrontAction, gameId: number, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (body === null || body === undefined) {
            throw new Error('Required parameter body was null or undefined when calling newFront.');
        }

        if (gameId === null || gameId === undefined) {
            throw new Error('Required parameter gameId was null or undefined when calling newFront.');
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json;charset=UTF-8'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.request<GameEngineDto>('post',`${this.basePath}/api/engine/${encodeURIComponent(String(gameId))}/actions/battle/new-front`,
            {
                body: body,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Remove wounds
     * Remove wounds from unit in front
     * @param body 
     * @param gameId Game ID
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public removeWounds(body: BattleWoundsAction, gameId: number, observe?: 'body', reportProgress?: boolean): Observable<GameEngineDto>;
    public removeWounds(body: BattleWoundsAction, gameId: number, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<GameEngineDto>>;
    public removeWounds(body: BattleWoundsAction, gameId: number, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<GameEngineDto>>;
    public removeWounds(body: BattleWoundsAction, gameId: number, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (body === null || body === undefined) {
            throw new Error('Required parameter body was null or undefined when calling removeWounds.');
        }

        if (gameId === null || gameId === undefined) {
            throw new Error('Required parameter gameId was null or undefined when calling removeWounds.');
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json;charset=UTF-8'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.request<GameEngineDto>('post',`${this.basePath}/api/engine/${encodeURIComponent(String(gameId))}/actions/battle/remove-wounds`,
            {
                body: body,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Return unit
     * Take battle hands or fronts unit and return to civilization board
     * @param body 
     * @param gameId Game ID
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public returnUnit(body: CivUuidAction, gameId: number, observe?: 'body', reportProgress?: boolean): Observable<GameEngineDto>;
    public returnUnit(body: CivUuidAction, gameId: number, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<GameEngineDto>>;
    public returnUnit(body: CivUuidAction, gameId: number, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<GameEngineDto>>;
    public returnUnit(body: CivUuidAction, gameId: number, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (body === null || body === undefined) {
            throw new Error('Required parameter body was null or undefined when calling returnUnit.');
        }

        if (gameId === null || gameId === undefined) {
            throw new Error('Required parameter gameId was null or undefined when calling returnUnit.');
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json;charset=UTF-8'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.request<GameEngineDto>('post',`${this.basePath}/api/engine/${encodeURIComponent(String(gameId))}/actions/battle/return-unit`,
            {
                body: body,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Reveal units
     * Reveal civilization hands units
     * @param body 
     * @param gameId Game ID
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public revealUnits(body: CivAction, gameId: number, observe?: 'body', reportProgress?: boolean): Observable<GameEngineDto>;
    public revealUnits(body: CivAction, gameId: number, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<GameEngineDto>>;
    public revealUnits(body: CivAction, gameId: number, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<GameEngineDto>>;
    public revealUnits(body: CivAction, gameId: number, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (body === null || body === undefined) {
            throw new Error('Required parameter body was null or undefined when calling revealUnits.');
        }

        if (gameId === null || gameId === undefined) {
            throw new Error('Required parameter gameId was null or undefined when calling revealUnits.');
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json;charset=UTF-8'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.request<GameEngineDto>('post',`${this.basePath}/api/engine/${encodeURIComponent(String(gameId))}/actions/battle/reveal-units`,
            {
                body: body,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Revive unit
     * Revive unit in one of fronts
     * @param body 
     * @param gameId Game ID
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public reviveUnit(body: CivUuidAction, gameId: number, observe?: 'body', reportProgress?: boolean): Observable<GameEngineDto>;
    public reviveUnit(body: CivUuidAction, gameId: number, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<GameEngineDto>>;
    public reviveUnit(body: CivUuidAction, gameId: number, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<GameEngineDto>>;
    public reviveUnit(body: CivUuidAction, gameId: number, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (body === null || body === undefined) {
            throw new Error('Required parameter body was null or undefined when calling reviveUnit.');
        }

        if (gameId === null || gameId === undefined) {
            throw new Error('Required parameter gameId was null or undefined when calling reviveUnit.');
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json;charset=UTF-8'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.request<GameEngineDto>('post',`${this.basePath}/api/engine/${encodeURIComponent(String(gameId))}/actions/battle/revive-unit`,
            {
                body: body,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Start battle
     * Start new battle between 2 players
     * @param body 
     * @param gameId Game ID
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public startBattle(body: BattleStartAction, gameId: number, observe?: 'body', reportProgress?: boolean): Observable<GameEngineDto>;
    public startBattle(body: BattleStartAction, gameId: number, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<GameEngineDto>>;
    public startBattle(body: BattleStartAction, gameId: number, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<GameEngineDto>>;
    public startBattle(body: BattleStartAction, gameId: number, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (body === null || body === undefined) {
            throw new Error('Required parameter body was null or undefined when calling startBattle.');
        }

        if (gameId === null || gameId === undefined) {
            throw new Error('Required parameter gameId was null or undefined when calling startBattle.');
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json;charset=UTF-8'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.request<GameEngineDto>('post',`${this.basePath}/api/engine/${encodeURIComponent(String(gameId))}/actions/battle/start`,
            {
                body: body,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

}
